import { keys } from './keys';

export const articlesUrlBase = {
  [keys.articleTypes.blogPost]: '/blog',
  [keys.articleTypes.crisisUpdate]: '/crisis-updates',
  [keys.articleTypes.pressRelease]: '/press/press-releases',
};
